import * as Yup from 'yup';
import { CampaignData } from '../models/campaign.ts';

export type UpdatePlaylistsDto = {
    campaignId: string,
    playlists: string[],
};

// deno-lint-ignore no-namespace
export namespace UpdatePlaylistsDto {
    export const spotifyPlaylistRegex = /^https:\/\/open\.spotify\.com\/playlist\/[a-zA-Z0-9]/;

    export function createValidation(): Yup.ObjectSchema<UpdatePlaylistsDto> {
        return Yup.object({
            campaignId: Yup.string().required('Product is required'),
            playlists: Yup.array().of(Yup.string().matches(spotifyPlaylistRegex, 'Invalid spotify playlist link')).nullable(),
        }).noUnknown();
    }
}

export type UpdatePlaylistsResponseDto = {
    campaign: CampaignData;
};
